// extracted by mini-css-extract-plugin
export default {"component":"yYw4Y"};